import { render, staticRenderFns } from "./addTeacherDialog.vue?vue&type=template&id=7b5f41c9&scoped=true"
import script from "./addTeacherDialog.vue?vue&type=script&lang=js"
export * from "./addTeacherDialog.vue?vue&type=script&lang=js"
import style0 from "./addTeacherDialog.vue?vue&type=style&index=0&id=7b5f41c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f41c9",
  null
  
)

export default component.exports